import { useState } from 'react';
import { isDebugModeEnabled } from '../utils/debug-mode';

const useDebugMode = (): boolean => {
    const [enabled] = useState<boolean>(isDebugModeEnabled);

    return enabled;
};

export default useDebugMode;
